import {Injectable} from '@angular/core';
import {StorageManagerGatewayCapacitor} from '../../adapters/real/app-services/storage-manager-gateway-capacitor';
import {BusinessLogoStoredModel} from '../../core-logic/models/business/business-logo-stored-model';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class BusinessLogoManagerService {
  private readonly logosStorageKey: string = 'businessesLogos';
  private storedBusinessesLogos: BusinessLogoStoredModel [] = [];
  constructor(private storageManagerGatewayCapacitor: StorageManagerGatewayCapacitor) {}

  public init() {
    this.storageManagerGatewayCapacitor.get(this.logosStorageKey).subscribe(storedBusinessesLogos => {
      storedBusinessesLogos ? this.storedBusinessesLogos = storedBusinessesLogos as BusinessLogoStoredModel [] :
          this.storedBusinessesLogos = [];
    });
  }

  public addBusinessLogo(businessLogoToStore: BusinessLogoStoredModel) {
    let previousStoredBusinessLogo = false;
    if (businessLogoToStore.business_id) {
      const storedBusinessLogoFoundedIndex = this.findStoredBusinessLogoIndexByBusinessId(businessLogoToStore);
      if (storedBusinessLogoFoundedIndex >= 0) {
        this.storedBusinessesLogos[storedBusinessLogoFoundedIndex] = this.makeBusinessLogoStoredModel(businessLogoToStore);
        this.storageManagerGatewayCapacitor.set(this.logosStorageKey, this.storedBusinessesLogos);
        previousStoredBusinessLogo = true;
      }
    }
    if (!previousStoredBusinessLogo) {
      this.storedBusinessesLogos.push(businessLogoToStore);
      this.storageManagerGatewayCapacitor.set(this.logosStorageKey, this.storedBusinessesLogos);
    }
  }

  public setBusinessIdToBusinessLogo(businessId: string, logoId: string) {
    this.storedBusinessesLogos.find( (storedBusinessLogoModel, index) => {
      if (this.isItSame(storedBusinessLogoModel.logo_id, logoId)) {
        this.storedBusinessesLogos[index].business_id = businessId;
        this.storageManagerGatewayCapacitor.set(this.logosStorageKey, this.storedBusinessesLogos);
      }
    });
  }

  public getLogoById(logoId: string): string {
    const storedBusinessLogoFounded: BusinessLogoStoredModel = this.storedBusinessesLogos
        .find(storedBusinessLogoModel => this.isItSame(storedBusinessLogoModel.logo_id, logoId));
    return storedBusinessLogoFounded ? storedBusinessLogoFounded.data : '';
  }

  public getLogoByBusinessId(businessId: string): BusinessLogoStoredModel {
    const storedBusinessLogoFounded: BusinessLogoStoredModel = this.findStoredBusinessLogoByBusinessId(businessId);
    return storedBusinessLogoFounded ? storedBusinessLogoFounded : {} as BusinessLogoStoredModel;
  }

  public removeLogoById(logoId: string): boolean {
    const storedBusinessesLogosLengthBeforeRemove: number = this.storedBusinessesLogos.length;
    _.remove(this.storedBusinessesLogos, storedBusinessLogoModel => this.isItSame(storedBusinessLogoModel.logo_id, logoId));
    if (this.isItRemovedSuccessfully(storedBusinessesLogosLengthBeforeRemove)) {
      this.storageManagerGatewayCapacitor.set(this.logosStorageKey, this.storedBusinessesLogos);
      return true;
    }
    return false;
  }

  public removeLogoByBusinessId(businessId: string): boolean {
    const storedBusinessesLogosLengthBeforeRemove: number = this.storedBusinessesLogos.length;
    _.remove(this.storedBusinessesLogos, storedBusinessLogoModel => this.isItSame(storedBusinessLogoModel.business_id, businessId));
    if (this.isItRemovedSuccessfully(storedBusinessesLogosLengthBeforeRemove)) {
      this.storageManagerGatewayCapacitor.set(this.logosStorageKey, this.storedBusinessesLogos);
      return true;
    }
    return false;
  }

  public getStoredBusinessesLogosWhoHaveEmptyBusinessId(): BusinessLogoStoredModel [] {
    const businessesLogosWithoutBusinessId: BusinessLogoStoredModel [] = [];
    this.storedBusinessesLogos.find(storedBusinessLogoModel => {
      if (_.isNull(storedBusinessLogoModel.business_id) || _.isEmpty(storedBusinessLogoModel.business_id)) {
        businessesLogosWithoutBusinessId.push(storedBusinessLogoModel);
      }
    });
    return businessesLogosWithoutBusinessId;
  }

  private isItSame = (firstWord: string, secondWord: string): boolean =>
     !_.isUndefined(firstWord) && !_.isUndefined(secondWord) && firstWord.localeCompare(secondWord) === 0

  private isItRemovedSuccessfully(storedBusinessesLogosLengthBeforeRemove: number) {
    return storedBusinessesLogosLengthBeforeRemove > 0 && storedBusinessesLogosLengthBeforeRemove > this.storedBusinessesLogos.length;
  }

  private findStoredBusinessLogoByBusinessId(businessId: string) {
    return this.storedBusinessesLogos
        .find(storedBusinessLogoModel => this.isItSame(storedBusinessLogoModel.business_id, businessId));
  }

  private findStoredBusinessLogoIndexByBusinessId(businessLogoToStore: BusinessLogoStoredModel) {
    return _.findIndex(this.storedBusinessesLogos,
        storedBusinessLogoModel => this.isItSame(storedBusinessLogoModel.business_id, businessLogoToStore.business_id));
  }

  private makeBusinessLogoStoredModel = (businessLogoToStore: BusinessLogoStoredModel) => ({
    logo_id: businessLogoToStore.logo_id,
    data: businessLogoToStore.data, business_id: businessLogoToStore.business_id
  })
}
